import React from 'react'
import './style/Library.css'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faBook } from '@fortawesome/free-solid-svg-icons'
import { faStream } from '@fortawesome/free-solid-svg-icons'
import { faUser } from '@fortawesome/free-solid-svg-icons'
import { faClone } from '@fortawesome/free-solid-svg-icons'
import { faPlus } from '@fortawesome/free-solid-svg-icons'

function Library() {
    return (
        <div className="library">
             <h2>Library</h2>
            <ul>
                <li> <FontAwesomeIcon icon={faBook} /> <p>Bestsellers</p></li>
                <li> <FontAwesomeIcon icon={faStream} /> <p>Daily top 100</p></li>
                <li> <FontAwesomeIcon icon={faUser} /> <p>Authors</p></li>
                <li> <FontAwesomeIcon icon={faClone} /> <p>Amazon books</p></li>
                <li> <FontAwesomeIcon icon={faPlus} /> <p>New releases</p></li>
            </ul>
        </div>
    )
}

export default Library
